(() => {
  const setup = () => {
    const header = document.querySelector('.lsn-header');
    if (!header || header.dataset.navigationReady) return;
    header.dataset.navigationReady = 'true';
    const desktopGroups = [...header.querySelectorAll('.lsn-desktop > .lsn-group')];
    desktopGroups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) desktopGroups.forEach(other => { if (other !== group) other.open = false; });
    }));
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) desktopGroups.forEach(group => { group.open = false; });
    });
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const group = event.target.closest('details[open]');
      if (group) { group.open = false; group.querySelector('summary').focus(); }
      else {
        const toggle = header.querySelector('[data-mobile-toggle]');
        if (toggle?.getAttribute('aria-expanded') === 'true') { toggle.click(); toggle.focus(); }
      }
    });
    header.querySelectorAll('.lsn-mobile details').forEach(group => {
      const summary = group.querySelector(':scope > summary');
      summary.addEventListener('click', event => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        event.preventDefault();
        if (group.dataset.animating) return;
        const opening = !group.open;
        const start = group.offsetHeight;
        if (opening) group.open = true;
        const end = opening ? group.offsetHeight : summary.offsetHeight;
        group.dataset.animating = 'true';
        group.style.overflow = 'hidden';
        const animation = group.animate({ height: [start + 'px', end + 'px'] }, { duration: 220, easing: 'ease-out' });
        const finish = () => { group.open = opening; group.style.overflow = ''; delete group.dataset.animating; };
        animation.onfinish = finish;
        animation.oncancel = finish;
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
